module.exports = __webpack_public_path__ + "static/media/portfolio.4e926ca3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/portfolio.svg
// module id = 1101
// module chunks = 0